import React from 'react'
import './header.css'
import {Github, Behance, Twitter} from 'react-bootstrap-icons'

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

const Header = () => {
  return (
    <Navbar expand="lg">
      <Container fluid>
        <Navbar.Brand href="/">Reho.</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href='/'>Home</Nav.Link>
            <Nav.Link href='/about'>About Me</Nav.Link>
            <Nav.Link href='/projects'>Projects</Nav.Link>
          </Nav>

          <Nav className='ms-auto'>
            <Nav.Link href=""><Github/></Nav.Link>
            <Nav.Link href=""><Twitter/></Nav.Link>
            <Nav.Link href=""><Behance/></Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default Header